import { Page, H1, H2, Lead, P, UL, Notice } from "../../public/primitives";

export const CookiesPage = () => (
  <Page testid="cookies-page">
    <H1>Cookies et stockage local</H1>
    <Lead>
      SecurePass n'utilise aujourd'hui aucun traceur publicitaire ni mesure d'audience tierce.
    </Lead>

    <H2 id="situation">Situation actuelle</H2>
    <P>Le service <b>n'utilise pas</b> :</P>
    <UL>
      <li>Google Analytics ;</li>
      <li>PostHog ;</li>
      <li>tracking publicitaire ;</li>
      <li>enregistrement de session (session replay) ;</li>
      <li>traceur marketing ou pixel publicitaire.</li>
    </UL>

    <H2 id="stockage-necessaire">Stockage local nécessaire</H2>
    <P>
      SecurePass utilise uniquement du stockage local strictement nécessaire au fonctionnement du
      service, notamment :
    </P>
    <UL>
      <li>le jeton d'authentification (lorsque vous êtes connecté) ;</li>
      <li>l'espace de travail actif ;</li>
      <li>un identifiant de session anonyme utilisé pour la protection anti-abus.</li>
    </UL>
    <P className="text-slate-500">
      Ces éléments ne sont pas des traceurs marketing. Leurs valeurs ne sont pas affichées ici.
    </P>

    <H2 id="traceurs-optionnels">Traceurs optionnels</H2>
    <P><b>Aucun actuellement.</b> SecurePass n'active aucun traceur optionnel.</P>
    <P className="text-slate-500">
      Certaines fonctionnalités déclenchées volontairement par l'utilisateur peuvent effectuer une
      requête vers un service externe. C'est notamment le cas de la vérification facultative d'un mot de
      passe dans Pwned Passwords (page « Tester un mot de passe »). Il ne s'agit pas d'un traceur.
    </P>

    <H2 id="preferences">Gestion des préférences</H2>
    <Notice tone="emerald" testid="cookies-preferences-note">
      Aucun traceur optionnel nécessitant votre consentement n'est activé.
    </Notice>
    <P className="text-slate-500">
      Si des traceurs optionnels devaient être introduits à l'avenir, une gestion des préférences serait
      mise en place à cet endroit.
    </P>
  </Page>
);

export default CookiesPage;
